<template>
    <div class="modal modal--confirm" v-bind:class="{ 'is-open' : isOpen }">
        <div class="modal__dialog">
            <div class="modal__content">
                {{ __('Add tile to link collection') }}
                <div class="has-margin-t30 has-text-left">
                    <label class="form__label" v-bind:for="'moveToStartdesk' + tile.id">{{ __('Tile category') }}</label>

                    <select class="form__control" v-bind:id="'category[' + index + ']'"
                            v-for="(categ, index) in selectedCategories"
                            v-model="selectedCategories[index]"
                            v-on:change="handleCategoryChange(index)"
                    >
                        <option v-for="cat in categories[index]" v-bind:value="cat.id">{{ cat.name }} ({{ cat.children.length }})</option>
                    </select>


                    <nav class="has-margin-t15 is-clearfix">
                        <a class="btn is-primary is-pulled-left" v-on:click="add">{{ __('Add') }}</a>
                    </nav>

                </div>

                <nav class="has-margin-t30 is-clearfix">
                    <a class="btn is-pulled-right" v-on:click="closeModal">{{ __('Cancel') }}</a>
                </nav>
            </div>
        </div>
        <div class="modal__backdrop" v-on:click="closeModal"></div>
    </div>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    export default {
        created: function () {
            // attach event listeners
            eventBus.$on('open-modal', this.openModal);
        },
        data: function () {
            return {
                categories: [],
                categoryId: null,
                isOpen: false,
                selectedCategories: []
            }
        },
        methods: {
            add: function () {
                eventBus.$emit('show-loader');

                this.$http.post(this.apiUrl + '/tiles/clone/' + this.tile.id, {
                    category_id: this.categoryId,
                    startdesk_id: null
                }).then(function (response) {
                    this.getStartdesks();

                    eventBus.$emit('hide-loader');

                    eventBus.$emit('show-alert', 'success', this.__('Tile has been successfully added.'));

                    this.closeModal();
                }, function (response) {
                    if (response.status == 422 && response.body.errors) {
                        this.errors = response.body.errors;
                    }

                    eventBus.$emit('hide-loader');

                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There were some errors validation the form. Please review and correct them.')
                    );

                    this.closeModal();
                }.bind(this));
            },
            closeModal: function () {
                this.isOpen = false;
            },
            confirm: function () {
                eventBus.$emit('confirm', this.id);

                this.closeModal();
            },
            handleCategoryChange: function (index) {
                for (let i = index + 1; i < this.categories.length; i++) {
                    this.$delete(this.categories, i);
                    this.$delete(this.selectedCategories, i);
                }
                this.getCategories(this.selectedCategories[index], index + 1);
                this.categoryId = this.selectedCategories[index];
            },
            init: function () {

            },
            getCategories: function (cat, index) {
                var parent = cat;
                if (typeof parent == 'undefined') {
                    parent = '';
                }

                if (typeof index == 'undefined') {
                    index = 0;
                }

                this.$delete(this.categories, index);

                eventBus.$emit('show-loader');

                this.$http.get(this.apiUrl + '/tiles/categories', {
                    params : {
                        page: 1,
                        filters: {
                            parent: parent
                        },
                        perPage: 0,
                        sortBy: 'name',
                        sortOrder: 'asc'
                    }
                }).then(function (response) {
                    this.$set(this.categories, index, response.body.original.data);
                    if (this.categories[index].length > 0 && typeof this.selectedCategories[index] == 'undefined') {
                        this.$set(this.selectedCategories, index, '');
                    }

                    eventBus.$emit('hide-loader');
                }.bind(this), function (response) {
                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There was an error retrieving data from the server.')
                    );

                    eventBus.$emit('hide-loader');
                });
            },
            openModal: function (id) {
                if (this.id == id) {
                    this.getCategories();

                    this.isOpen = true;
                }
            }
        },
        mounted: function () {
            this.init();
        },
        props: {
            id: {
                required: true,
                type: [Number, String]
            },
            tile: {
                required: null,
                type: Object
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/AddTileToLinkCollection.vue